import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, finalize, tap } from 'rxjs';
import { LoadingService } from '../../core/services/loading.service';
import { environment } from '../../../environments/environment';
import { UserAuthService } from '../services/user-auth.service';
import { SharedService } from '../services/shared.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  totalRequests = 0;
  requestsCompleted = 0;
  constructor(
    private router: Router,
    private loadingService: LoadingService,
    private authService: UserAuthService,
    private sharedService: SharedService,
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.isOperatorPage();
    this.totalRequests++;
    this.loadingService.setLoading(true);

    if (this.authService.getUser()) {
      var paceFillsUserId = localStorage.getItem('PACEFILLS_USER_ID');
      if (paceFillsUserId) {
        request = request.clone({
          setHeaders: {
            PaceFillsUserId: paceFillsUserId.toString(),
          },
        });
      }
    }

    // edit request
    request = request.clone({
      withCredentials: true,
    });

    return next.handle(request).pipe(
      finalize(() => {
        this.requestsCompleted++;
        if (this.requestsCompleted === this.totalRequests) {
          this.loadingService.setLoading(false);
          this.totalRequests = 0;
          this.requestsCompleted = 0;
        }
      }),
      tap(
        () => { },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (
              err.status === 401 ||
              err.status === 403 ||
              err.status === 302
            ) {
              localStorage.clear();
              //reroute to login site
              var url = environment.authUrl;
              window.location.href = url + 'logout';
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        }
      )
    );
  }

  isOperatorPage() {
    if (localStorage.getItem('OPERATOR')) {
      return true;
    } else {
      return false;
    }
  }
}

// URL for implementation
// https://medium.com/@vergarawalterdomenico/secure-api-calls-in-angular-and-react-with-jwt-token-interceptor-a-ready-to-use-example-790dd059f338
